/* GleamCanvas theme scripts: header, cart drawer (Shopify AJAX Cart API),
   product variants, collection filters, recommendations, accordions. */
(function () {
  "use strict";
  var GC = window.GC || {};

  function formatMoney(cents) {
    var format = GC.moneyFormat || "${{amount}}";
    var n = (cents / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === "amount_no_decimals") return withCommas.split(".")[0];
      if (key === "amount_with_comma_separator") return n.replace(".", ",");
      if (key === "amount_no_decimals_with_comma_separator") return withCommas.split(".")[0].replace(/,/g, ".");
      return withCommas;
    });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }

  /* ---------- Announcement bar: one message at a time on narrow screens ---------- */
  document.querySelectorAll("[data-announce]").forEach(function (track) {
    var msgs = track.children, i = 0;
    if (!msgs.length) return;
    msgs[0].classList.add("is-active");
    if (msgs.length < 2) return;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, 4000);
  });

  /* ---------- Mobile menu ---------- */
  var menuBtn = document.querySelector("[data-menu-toggle]");
  var mobileNav = document.getElementById("MobileNav");
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", function () {
      var open = mobileNav.hasAttribute("hidden");
      mobileNav.toggleAttribute("hidden", !open);
      menuBtn.setAttribute("aria-expanded", String(open));
    });
  }
  // Close desktop dropdowns when clicking elsewhere
  document.addEventListener("click", function (e) {
    document.querySelectorAll(".nav-dropdown[open]").forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute("open"); });
  });

  /* ---------- Accordions: one open at a time per group ---------- */
  document.querySelectorAll("[data-accordion]").forEach(function (group) {
    group.addEventListener("toggle", function (e) {
      if (e.target.open) group.querySelectorAll("details").forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById("CartDrawer");
  var strings = {};
  try { strings = JSON.parse(document.getElementById("CartStrings").textContent); } catch (e) {}

  function openCart() { if (!drawer) return; drawer.removeAttribute("hidden"); document.body.classList.add("no-scroll"); }
  function closeCart() { if (!drawer) return; drawer.setAttribute("hidden", ""); document.body.classList.remove("no-scroll"); }

  function renderCart(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.toggleAttribute("hidden", cart.item_count === 0);
    });
    if (!drawer) return;
    var items = drawer.querySelector("[data-cart-items]");
    if (!cart.items.length) {
      items.innerHTML = document.getElementById("CartEmpty").innerHTML;
    } else {
      items.innerHTML = cart.items.map(function (item, idx) {
        var img = item.image ? '<img src="' + item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=200" + '" alt="">' : "<span></span>";
        var variant = item.variant_title && item.product_has_only_default_variant === false ? '<p class="fine left">' + escapeHtml(item.variant_title) + "</p>" : "";
        return '<div class="cart-line">' + img + "<div>" +
          '<a href="' + item.url + '">' + escapeHtml(item.product_title) + "</a>" + variant +
          '<div class="qty"><button type="button" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(strings.decrease || "-") + '">−</button>' +
          "<span>" + item.quantity + "</span>" +
          '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(strings.increase || "+") + '">+</button></div>' +
          "</div><strong>" + (item.original_line_price > item.final_line_price ? '<s class="price-compare">' + formatMoney(item.original_line_price) + "</s> " : "") + formatMoney(item.final_line_price) + "</strong></div>";
      }).join("");
    }
    drawer.querySelector("[data-cart-subtotal]").textContent = formatMoney(cart.total_price);

    var ship = drawer.querySelector("[data-cart-ship]");
    var threshold = GC.freeShipping || 0;
    if (!threshold || !cart.items.length) { ship.innerHTML = ""; return; }
    var left = threshold - cart.total_price;
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    var msg = left > 0 ? (strings.left || "").replace("__AMOUNT__", "<strong>" + formatMoney(left) + "</strong>") : "<strong>" + (strings.done || "") + "</strong>";
    ship.innerHTML = "<p>" + msg + '</p><div class="ship-bar"><span style="width:' + pct + '%"></span></div>';
  }

  function fetchCart() {
    return fetch(GC.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(id, quantity, btn) {
    if (btn) btn.setAttribute("aria-busy", "true");
    return fetch(GC.routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
      .then(fetchCart)
      .then(function () { if (GC.cartDrawer !== false) openCart(); })
      .catch(function (err) { alert((err && (err.description || err.message)) || "Could not add to cart."); })
      .finally(function () { if (btn) btn.removeAttribute("aria-busy"); });
  }
  window.GCAddToCart = addToCart;

  if (drawer) {
    document.querySelectorAll("[data-open-cart]").forEach(function (a) {
      a.addEventListener("click", function (e) { e.preventDefault(); fetchCart().then(openCart); });
    });
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-close-cart]")) closeCart();
      var b = e.target.closest("[data-line]");
      if (b) {
        fetch(GC.routes.cartChange + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qty) })
        }).then(function (r) { return r.json(); }).then(renderCart);
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  }

  // Quick add buttons on product cards (single-variant products)
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add]");
    if (b) { e.preventDefault(); addToCart(b.getAttribute("data-add"), 1, b); }
  });

  /* ---------- Product page ---------- */
  document.querySelectorAll("[data-product]").forEach(function (root) {
    var form = root.querySelector("[data-product-form]");
    var mainImg = root.querySelector(".pdp-main-img");

    // Thumbnails
    // Thumbnails (photos and videos)
    root.querySelectorAll("[data-thumb], [data-thumb-video]").forEach(function (b) {
      b.addEventListener("click", function () {
        root.querySelectorAll("[data-video-for]").forEach(function (box) {
          var v = box.querySelector("video"); if (v) v.pause(); box.hidden = true;
        });
        if (b.dataset.thumbVideo) {
          var box = root.querySelector('[data-video-for="' + b.dataset.thumbVideo + '"]');
          if (mainImg) mainImg.hidden = true;
          if (box) { box.hidden = false; var v = box.querySelector("video"); if (v && v.play) v.play().catch(function () {}); }
        } else if (mainImg) { mainImg.hidden = false; mainImg.removeAttribute("srcset"); mainImg.src = b.dataset.thumb; }
        root.querySelectorAll("[data-thumb], [data-thumb-video]").forEach(function (x) { x.removeAttribute("aria-current"); });
        b.setAttribute("aria-current", "true");
      });
    });

    if (!form) return;
    var qtyInput = form.querySelector("[data-qty-input]");
    form.querySelectorAll("[data-qty-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qtyStep));
      });
    });

    // Variants
    var variantsEl = root.querySelector("[data-variants]");
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = form.querySelector("[data-variant-id]");
    var addBtn = form.querySelector("[data-add-button]");
    var addLabel = addBtn ? addBtn.textContent.trim() : "";
    var priceEl = root.querySelector("[data-price]");
    var compareEl = root.querySelector("[data-compare]");
    var selects = form.querySelectorAll("[data-option-index]");
    selects.forEach(function (sel) {
      sel.addEventListener("change", function () {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; return; }
        idInput.value = v.id;
        priceEl.textContent = formatMoney(v.price);
        var salePriceEl = root.querySelector("[data-sale-price]"), saleRegEl = root.querySelector("[data-sale-reg]");
        if (salePriceEl) salePriceEl.textContent = formatMoney(v.price - Math.floor(v.price * 15 / 100));
        if (saleRegEl) saleRegEl.textContent = formatMoney(v.price);
        if (compareEl) {
          compareEl.textContent = v.compare_at_price ? formatMoney(v.compare_at_price) : "";
          compareEl.toggleAttribute("hidden", !(v.compare_at_price > v.price));
        }
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : "Sold out";
        if (v.featured_image && mainImg) { mainImg.removeAttribute("srcset"); mainImg.src = v.featured_image.src; }
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url.toString());
      });
    });

    // Submit via AJAX so the drawer opens; falls back to normal POST without JS
    form.addEventListener("submit", function (e) {
      if (!drawer) return;
      e.preventDefault();
      addToCart(idInput.value, qtyInput.value, addBtn);
    });
  });

  /* ---------- Shop / collection page: filters, chips and sort in the browser (same as preview shop.html) ---------- */
  document.querySelectorAll("[data-shop]").forEach(function (root) {
    var isAll = root.dataset.all === "true";
    var filters = root.querySelector(".filters");
    var items = Array.prototype.slice.call(root.querySelectorAll(".shop-item"));
    var results = root.querySelector("[data-shop-results]"), empty = root.querySelector("[data-shop-empty]");
    var catBoxes = Array.prototype.slice.call(filters.querySelectorAll('[name="cat"]'));
    var params = new URLSearchParams(location.search);
    var state = {
      cats: catBoxes.filter(function (i) { return i.checked; }).map(function (i) { return i.value; }),
      light: false, isNew: false, price: "", sort: "featured"
    };
    if (isAll && params.get("cat")) state.cats = params.get("cat").split(",");
    var title = document.querySelector("[data-shop-title]"), crumb = document.querySelector("[data-shop-crumb]"), blurb = document.querySelector("[data-shop-blurb]");
    var base = { title: root.dataset.allTitle || (title && title.textContent), blurb: root.dataset.allBlurb || (blurb ? blurb.textContent : "") };

    function catBox(id) { return catBoxes.filter(function (i) { return i.value === id; })[0]; }
    function sync() {
      catBoxes.forEach(function (i) { i.checked = state.cats.indexOf(i.value) > -1; });
      filters.querySelector('[name="light"]').checked = state.light;
      filters.querySelector('[name="new"]').checked = state.isNew;
      filters.querySelectorAll('[name="price"]').forEach(function (i) { i.checked = i.value === state.price; });
    }
    function render() {
      var shown = items.filter(function (el) {
        var d = el.dataset, p = parseFloat(d.price);
        if (isAll && state.cats.length && state.cats.indexOf(d.cat) < 0) return false;
        if (state.light && !d.light) return false;
        if (state.isNew && !d["new"]) return false;
        if (state.price) { var r = state.price.split("-"); if (p < +r[0] || p >= +r[1]) return false; }
        return true;
      });
      var sorters = {
        featured: function (a, b) { return a.dataset.index - b.dataset.index; },
        "new": function (a, b) { return (b.dataset["new"] ? 1 : 0) - (a.dataset["new"] ? 1 : 0) || a.dataset.index - b.dataset.index; },
        "price-asc": function (a, b) { return a.dataset.price - b.dataset.price; },
        "price-desc": function (a, b) { return b.dataset.price - a.dataset.price; },
        az: function (a, b) { return a.dataset.name.localeCompare(b.dataset.name); }
      };
      items.slice().sort(sorters[state.sort]).forEach(function (el) { results.insertBefore(el, empty); });
      items.forEach(function (el) { el.hidden = shown.indexOf(el) < 0; });
      empty.hidden = shown.length > 0;
      var count = root.querySelector("[data-shop-count]");
      if (count) count.textContent = shown.length + (shown.length === 1 ? " kit" : " kits");
      if (isAll) { // the title follows a single chosen collection, like the preview
        var one = state.cats.length === 1 ? catBox(state.cats[0]) : null;
        if (title) title.textContent = one ? one.dataset.title : base.title;
        if (crumb) crumb.textContent = one ? one.dataset.title : "Shop All";
        if (blurb) blurb.textContent = one ? one.dataset.blurb : base.blurb;
      }
      var chips = [];
      state.cats.forEach(function (c) { var b = catBox(c); if (b) chips.push(["cat", c, b.dataset.title]); });
      if (state.light) chips.push(["light", "", "Lights up"]);
      if (state.isNew) chips.push(["new", "", "New releases"]);
      if (state.price) chips.push(["price", "", filters.querySelector('[name="price"][value="' + state.price + '"]').parentNode.textContent.trim()]);
      root.querySelector("[data-shop-chips]").innerHTML = chips.map(function (c) {
        return '<button class="chip" type="button" data-k="' + c[0] + '" data-v="' + c[1] + '">' + c[2] + ' <span aria-hidden="true">×</span><span class="sr-only">Remove filter</span></button>';
      }).join("");
    }
    // On a single collection, changing the Collection boxes opens the matching page
    function goCats(cats) {
      if (cats.length === 1) { location.href = catBox(cats[0]).dataset.url; return; }
      location.href = root.dataset.allUrl + (cats.length ? "?cat=" + cats.join(",") : "");
    }
    filters.addEventListener("change", function (e) {
      var t = e.target;
      if (t.name === "cat") {
        var cats = catBoxes.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
        if (!isAll) return goCats(cats);
        state.cats = cats;
      }
      if (t.name === "light") state.light = t.checked;
      if (t.name === "new") state.isNew = t.checked;
      if (t.name === "price") state.price = t.value;
      render();
    });
    root.querySelector("[data-shop-chips]").addEventListener("click", function (e) {
      var c = e.target.closest(".chip"); if (!c) return;
      var k = c.dataset.k, v = c.dataset.v;
      if (k === "cat") { state.cats = state.cats.filter(function (x) { return x !== v; }); if (!isAll) return goCats(state.cats); }
      if (k === "light") state.light = false;
      if (k === "new") state.isNew = false;
      if (k === "price") state.price = "";
      sync(); render();
    });
    root.querySelectorAll("[data-shop-clear]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!isAll) return goCats([]);
        state.cats = []; state.light = false; state.isNew = false; state.price = "";
        sync(); render();
      });
    });
    var sortSel = root.querySelector("[data-shop-sort]");
    sortSel.addEventListener("change", function () { state.sort = sortSel.value; render(); });
    var toggle = root.querySelector("[data-filter-toggle]");
    if (toggle) toggle.addEventListener("click", function () {
      var open = filters.classList.toggle("open");
      toggle.setAttribute("aria-expanded", String(open));
    });
    sync(); render();
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll("[data-recommendations]").forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector("[data-recommendations]");
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      else el.remove();
    }).catch(function () {});
  });

  /* ---------- Confirm-before-submit forms (address delete) ---------- */
  document.querySelectorAll("form[data-confirm]").forEach(function (f) {
    f.addEventListener("submit", function (e) { if (!window.confirm(f.dataset.confirm)) e.preventDefault(); });
  });

  /* ---------- Address forms: preselect saved country ---------- */
  document.querySelectorAll("select[data-default]").forEach(function (s) {
    if (s.dataset.default) s.value = s.dataset.default;
  });
})();

/* ---------- MOBILE TRIAL (Oct 2026): swipe hints, "Read more" on long descriptions, sticky Add to cart bar.
   Same code in site/assets/js/main.js and shopify-theme/assets/gleamcanvas.js. Styles: "MOBILE TRIAL" block. ---------- */
(function () {
  function ready(fn) { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn); else fn(); }
  ready(function () {
    document.querySelectorAll(".pillars, .steps.rituals").forEach(function (row) {
      if (row.nextElementSibling && row.nextElementSibling.classList.contains("swipe-hint")) return;
      var hint = document.createElement("p"); hint.className = "swipe-hint"; hint.setAttribute("aria-hidden", "true"); hint.textContent = "Swipe for more →";
      row.parentNode.insertBefore(hint, row.nextSibling);
    });
    if (!window.matchMedia || !window.matchMedia("(max-width: 700px)").matches) return;
    // Long product descriptions fold up
    document.querySelectorAll(".pdp .faq-answer").forEach(function (box) {
      if (box.scrollHeight < 420) return;
      box.classList.add("is-clamped");
      var more = document.createElement("button"); more.type = "button"; more.className = "read-more"; more.textContent = "Read more";
      more.addEventListener("click", function () {
        var open = box.classList.toggle("is-clamped");
        more.textContent = open ? "Read more" : "Show less";
      });
      box.parentNode.insertBefore(more, box.nextSibling);
    });
    // Sticky Add to cart bar on product pages
    var add = document.querySelector(".pdp [data-add-button], .pdp #add");
    if (!add || !("IntersectionObserver" in window)) return;
    var title = document.querySelector(".pdp-info h1"), price = document.querySelector(document.documentElement.classList.contains("gc-sale-on") ? ".pdp [data-sale-price]" : ".pdp [data-price], .pdp #price");
    var bar = document.createElement("div"); bar.className = "buy-bar";
    bar.innerHTML = '<div class="buy-bar-text"><strong></strong><span></span></div><button type="button" class="btn btn-primary">Add to cart</button>';
    bar.querySelector("strong").textContent = title ? title.textContent.trim() : "";
    document.body.appendChild(bar);
    var barBtn = bar.querySelector("button");
    function sync() {
      bar.querySelector("span").textContent = price ? price.textContent.trim() : "";
      barBtn.disabled = add.disabled; barBtn.textContent = add.disabled ? add.textContent.trim() : "Add to cart";
    }
    barBtn.addEventListener("click", function () { add.click(); });
    new IntersectionObserver(function (es) { sync(); bar.classList.toggle("is-on", !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(add);
  });
})();
